"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _reduce2 = _interopRequireDefault(require("lodash/reduce"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reduxForm = require("redux-form");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _forms = require("../forms");

var _StateSelect = _interopRequireDefault(require("../stateselect/StateSelect"));

var _GooglePlacesAutocompleteComponent = _interopRequireDefault(require("../googlePlacesAPI/GooglePlacesAutocompleteComponent"));

var _span;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StateSelectField = (0, _forms.createFieldComponent)(_StateSelect.default);

var addColonAfterLabel = function addColonAfterLabel(text, addColonAfterText) {
  return addColonAfterText ? "".concat(text, ":") : text;
};

var markRequiredText = function markRequiredText(text, addAsteriskAfterText) {
  return addAsteriskAfterText ? /*#__PURE__*/(0, _jsx2.default)("span", {}, void 0, text, " ", _span || (_span = /*#__PURE__*/(0, _jsx2.default)("span", {
    className: "text-danger"
  }, void 0, "*"))) : text;
};

function AddressComponent(props) {
  /* -------------------- Setup -------------------- */
  var showFieldWatermarkText = props.showFieldWatermarkText,
      showFieldLabels = props.showFieldLabels,
      showRequiredFieldAsterisks = props.showRequiredFieldAsterisks,
      showColonAfterLabels = props.showColonAfterLabels,
      useAddressShortForm = props.useAddressShortForm,
      prefixNameForFieldIds = props.prefixNameForFieldIds,
      enableGoogleAutocomplete = props.enableGoogleAutocomplete,
      useStateAbbreviationValue = props.useStateAbbreviationValue,
      stateChooseText = props.stateChooseText,
      fieldLabels = props.fieldLabels,
      allFieldsTabIndex = props.allFieldsTabIndex;

  var _Object$assign = Object.assign({}, AddressComponent.defaultProps.fieldLabels, fieldLabels),
      firstLineLabelText = _Object$assign.firstLineLabelText,
      secondLineLabelText = _Object$assign.secondLineLabelText,
      cityLabelText = _Object$assign.cityLabelText,
      stateLabelText = _Object$assign.stateLabelText,
      zipCodeLabelText = _Object$assign.zipCodeLabelText;

  var firstLinePlaceholderAndLabelText = firstLineLabelText;
  var secondLinePlaceholderAndLabelText = secondLineLabelText;
  var cityPlaceholderAndLabelText = cityLabelText;
  var statePlaceholderAndLabelText = stateLabelText;
  var zipCodePlaceholderAndLabelText = zipCodeLabelText;
  var firstLineLabel = markRequiredText(addColonAfterLabel(firstLinePlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var secondLineLabel = addColonAfterLabel(secondLinePlaceholderAndLabelText, showColonAfterLabels);
  var cityLabel = markRequiredText(addColonAfterLabel(cityPlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var stateLabel = markRequiredText(addColonAfterLabel(statePlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var zipCodeLabel = markRequiredText(addColonAfterLabel(zipCodePlaceholderAndLabelText, showColonAfterLabels), showRequiredFieldAsterisks);
  var tabIndex = allFieldsTabIndex || 0;
  /* -------------------- Helpers -------------------- */

  function fillAddress(place) {
    var notUsingShortForm = !props.useAddressShortForm;
    var parentFormUpdateMethod = props.parentFormUpdateMethod;
    var addressPieces = (0, _reduce2.default)(place.address_components, function (addressMap, addressComponent) {
      return _objectSpread(_objectSpread({}, addressMap), {}, (0, _defineProperty2.default)({}, addressComponent.types[0], addressComponent.short_name));
    }, {});
    var addressPiecesNotEmpty = !(0, _isEmpty2.default)(addressPieces);

    if (addressPiecesNotEmpty) {
      var streetNumber = (0, _get2.default)(addressPieces, 'street_number', '');
      parentFormUpdateMethod('address.firstLine', "".concat(streetNumber, " ").concat(addressPieces.route));
      parentFormUpdateMethod('address.city', addressPieces.locality);
      parentFormUpdateMethod('address.zipCode', addressPieces.postal_code);

      if (notUsingShortForm) {
        parentFormUpdateMethod('address.state', addressPieces.administrative_area_level_1);
      }
    }
  }
  /* -------------------- Rendered Elements -------------------- */


  return /*#__PURE__*/(0, _jsx2.default)(_Row.default, {
    componentClass: _reduxForm.FormSection,
    name: props.name
  }, void 0, /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
    xs: 12
  }, void 0, enableGoogleAutocomplete ? /*#__PURE__*/_react.default.createElement(_GooglePlacesAutocompleteComponent.default, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--first-line"),
    addressSelected: function addressSelected(place) {
      return fillAddress(place);
    },
    types: ['address'],
    restrictions: {
      country: 'us'
    },
    name: "firstLine",
    component: _forms.InputField,
    type: "text",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: firstLinePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: firstLineLabel
  } : {})) : /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--first-line"),
    name: "firstLine",
    component: _forms.InputField,
    type: "text",
    autoComplete: "address-line1",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: firstLinePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: firstLineLabel
  } : {})), !useAddressShortForm ? /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--second-line"),
    name: "secondLine",
    component: _forms.InputField,
    type: "text",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: secondLinePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: secondLineLabel
  } : {})) : null), /*#__PURE__*/_react.default.createElement(_Col.default, (0, _extends2.default)({
    xs: 12
  }, !useAddressShortForm ? {
    sm: 4
  } : {}), /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--city"),
    name: "city",
    component: _forms.InputField,
    type: "text",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: cityPlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: cityLabel
  } : {}))), !useAddressShortForm ? /*#__PURE__*/(0, _jsx2.default)(_Col.default, {
    xs: 12,
    sm: 4
  }, void 0, /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--state"),
    name: "state",
    component: StateSelectField,
    useAbbreviationValue: useStateAbbreviationValue,
    chooseText: stateChooseText,
    tabIndex: tabIndex
  }, showFieldLabels ? {
    label: stateLabel
  } : {}))) : null, /*#__PURE__*/_react.default.createElement(_Col.default, (0, _extends2.default)({
    xs: 12
  }, !useAddressShortForm ? {
    sm: 4
  } : {}), /*#__PURE__*/_react.default.createElement(_reduxForm.Field, (0, _extends2.default)({
    id: "".concat(prefixNameForFieldIds, "--zip-code"),
    name: "zipCode",
    component: _forms.InputField,
    type: "tel",
    tabIndex: tabIndex
  }, showFieldWatermarkText ? {
    placeholder: zipCodePlaceholderAndLabelText
  } : {}, showFieldLabels ? {
    label: zipCodeLabel
  } : {}))));
}

AddressComponent.defaultProps = {
  name: 'address',
  // Note: 'address' value should not change, or you will break the validation rules
  showFieldLabels: true,
  showFieldWatermarkText: true,
  showRequiredFieldAsterisks: true,
  showColonAfterLabels: true,
  useAddressShortForm: false,
  prefixNameForFieldIds: 'address-component',
  parentFormUpdateMethod: function parentFormUpdateMethod(fieldName, value) {},
  enableGoogleAutocomplete: false,
  useStateAbbreviationValue: true,
  stateChooseText: 'Select One',
  fieldLabels: {
    firstLineLabelText: 'Street Address 1',
    secondLineLabelText: 'Street Address 2',
    cityLabelText: 'City',
    stateLabelText: 'State',
    zipCodeLabelText: 'Zip Code'
  }
};

// Composition and Exports
var _default = (0, _compose.default)(_pure.default)(AddressComponent);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/addresscomponent/AddressComponent.js
// module id = 4260
// module chunks = 9